import templates from "../../api/mctemplates";
import { perPageCount } from "@/common/constants";
import { dummyRows } from "@/common/functions";
import { getApiBaseUrl } from "@/common/http.header";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    filter: {
      page: 1,
      per_page: perPageCount,
      name: "",
      status: "",
      sort_field: "modifiedDate",
      sort_order: "desc",
    },
    totalItems: 0,
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }
    return state.items.map((item) => {
      var icon = "inactive";
      if (item.status === 1) {
        icon = "circle-check";
      }
      var data = {
        id: item.id,
        name: {
          title: item.name,
          text: "",
          image:
            getApiBaseUrl() + "/uploads/template_images/" + item.creativeImg,
        },
        status: { text: item.status === 1 ? "Active" : "Inactive", type: icon },
        modifiedDate: item.modifiedDate,
        action: { Edit: false, Delete: false },
      };
      if (item.status === 1) {
        data.action["Inactive"] = false;
        data.action["Active"] = true;
      } else {
        data.action["Active"] = false;
        data.action["Inactive"] = true;
      }
      return data;
    });
  },
};

// actions
const actions = {
  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.per_page !== params.per_page ||
      filter.name !== params.name ||
      filter.status !== params.status ||
      filter.sort_field !== params.sort_field ||
      filter.sort_order !== params.sort_order
    ) {
      commit("setFilter", { ...params });
      templates.fetchItems(params, (data) => {
        commit("setItems", { items: data.items });
        commit("setTotalItems", data.total);
        commit("setLoaded", true);
      });
    }
  },

  refreshItems({ commit, state, dispatch }) {
    commit("setLoaded", false);
    dispatch("fetchItems", state.filter);
  },

  statusChange(_, params) {
    return templates.statusChange(params);
  },
  resetState({ commit }) {
    commit("resetState");
  },
};

// mutations
const mutations = {
  setItems(state, { items }) {
    state.items = items;
  },

  setFilter(state, data) {
    state.filter = data;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },

  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
